<template>
  <div class="flex justify-center items-center">
    <div class="flex justify-center items-center">
      <img
        :src="require(`@/assets/img/loader.gif`)"
        alt="loading..."
        class="w-64 h-64"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "WaitingPage",
  methods: {
    ...mapActions(["signupVerification", "verifyEmail"]),
  },
  async created() {
    const token = this.$route.params.token;

    if (token) {
      this.verifyEmail(token).then(() => {
        // this.$router.push({ name: "Register", query: { step: 4 } });
        this.$router.push({ name: "Login" });
      });
    } else {
      this.signupVerification({ id: this.user.id }).then(() => {
        this.$router.push({ name: "Register", query: { step: 4 } });
      });
    }
  },
};
</script>